import configObserver from './configObserver';
import loginObserver from './loginObserver';

// only default export observers that are to be subscribed immediately after tha app starts
export default {
  configObserver,
  loginObserver,
};
